import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormArray } from "@angular/forms";
import { GoogleMapsLoaderService } from '../../_services/google-maps-loader.service';
import { TransporteurService } from '../../_services/transporteur.service';
import { HttpClient } from '@angular/common/http';
import { ToastService } from "../../_services/toast.service";
import { SecurityService } from '../../_services/security.service';

declare let google: any;
export type CityType = { city: string, region: string, country: string, lat: number, lng: number };
export type VehicleType = { vehicleType: string };
export type QuantityType = { quantity: string };
export type TransportType = {
  departure: CityType,
  company_id?: string,
  arrival: CityType,
  quantity: string[],
  vehicleType: string[],
  days: string[],
  infos: string,
  distance: string
}

interface UserCompany {
  company: number
}
//export type TransporteurType = { departure: CityType, arrival: CityType };

@Component({
  selector: 'app-transporteur',
  templateUrl: './transporteur.component.html',
  styleUrls: ['./transporteur.component.css']
})

export class TransporteurComponent implements OnInit, AfterViewInit {
  @ViewChild("mapContainer") mapContainer: ElementRef;
  @ViewChild("departureInput") departureInput: ElementRef;
  @ViewChild("arrivalInput") arrivalInput: ElementRef;

  userCompany: UserCompany;
  map: any;
  departureMarker: any;
  arrivalMarker: any;
  directionsService: any;
  directionsRenderers: any[] = [];
  markers: any[] = [];
  selectedCompany: any;
  selectedTransport: any;
  departureAutocomplete: any;
  arrivalAutocomplete: any;
  countries: string[] = [];
  isAdmin: boolean = false

  transporteurs: TransportType[] = [];

  addItinerary: FormGroup;
  quantityOptions: string[] = ['Groupage', 'Demi-lot', 'Complet'];
  vehicleTypeOptions: string[] = [
    'Frigo : Congelé',
    'Frigo : Frais',
    'Frigo : Sec',
    'Frigo : Bi-temperature',
    'Taut liner',
    'Express'
  ];
  daysOptions: string[] = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

  filters = new FormGroup({
    transporter_id: new FormControl(),
    country: new FormControl(),
  })


  constructor(
    private googleMapsLoader: GoogleMapsLoaderService,
    private transporteurService: TransporteurService,
    private toastService: ToastService,
    private http: HttpClient,
    private securityService: SecurityService,
    private fb: FormBuilder) { }
    
  ngOnInit() {
    this.securityService.isAdmin().then(
      (isAdmin:boolean) => {
        this.isAdmin = isAdmin;
        if(!isAdmin) {
          this.setTransporterIdForUser();
        }
      },
      (error) => {
        console.error('Erreur lors de la vérification du rôle admin', error);
      }
    );

    this.addItinerary = this.fb.group({
      departure: new FormControl(),
      departureRegion: new FormControl(),
      departureCountry: new FormControl(),
      arrival: new FormControl(),
      arrivalRegion: new FormControl(),
      arrivalCountry: new FormControl(),
      infos: new FormControl(),
      quantity: this.fb.array(this.quantityOptions.map(x => new FormControl(false))),
      vehicleType: this.fb.array(this.vehicleTypeOptions.map(x => new FormControl(false))),
      days: this.fb.array(this.daysOptions.map(x => new FormControl(false)))
    })
    this.getTransportsList();
    this.loadCountries(); 

    this.filters.get('transporter_id').valueChanges.debounceTime(250).subscribe((company_id) => {
      this.selectedCompany = company_id;
      this.getTransportsList();
    })

    this.filters.get('country').valueChanges.debounceTime(250).subscribe(() => {
      this.getTransportsList();
    });
  }


  async setTransporterIdForUser() {
    const userResponse = await this.securityService.userInfos(); // Assurez-vous que cette méthode existe
    const user = userResponse as UserCompany;
    
    if (user) {
      this.filters.get('transporter_id').setValue(user.company);
    }
    //this.filters.get('transporter_id').setValue(userId.company);
  }
  
  get quantityFormArray() {
    return this.addItinerary.get('quantity') as FormArray;
  }

  get vehicleTypeFormArray() {
    return this.addItinerary.get('vehicleType') as FormArray;
  }

  get daysFormArray() {
    return this.addItinerary.get('days') as FormArray;
  }

  ngAfterViewInit(): void {
    this.googleMapsLoader.load().then(() => {
      this.loadMap();
      this.initializeAutocomplete();
      this.initializeDirectionsService();
    }).catch(error => {
      console.error('erreur lors du chargement de google maps', error);
    });
  }
  
  loadMap(): void {
    const mapOptions = {
      center: {  lat: 48.8566, lng: 2.3522 },
      zoom: 5,
    };
    
    this.map = new google.maps.Map(this.mapContainer.nativeElement, mapOptions);
  }
  
  initializeDirectionsService(): void {
    this.directionsService = new google.maps.DirectionsService();
  }

  initializeAutocomplete(): void {
    this.departureAutocomplete = new google.maps.places.Autocomplete(this.departureInput.nativeElement, { types: ['(cities)']});
    this.arrivalAutocomplete = new google.maps.places.Autocomplete(this.arrivalInput.nativeElement, { types: ['(cities)']});
    
    this.departureAutocomplete.addListener('place_changed', async () => {
      const place = this.departureAutocomplete.getPlace();

      if (!place.geometry || !place.geometry.location) {
        return;
      }
      const region = this.getRegionFromPlace(place);
      const codePays = this.getCountryCodeFromPlace(place);
      let cp = this.getPostalCodeFromPlace(place);
      const country = this.getCountryFromPlace(place);
      const city = place.name;

      if (!cp) {
        cp = await this.fetchPostalCode(place.geometry.location.lat(), place.geometry.location.lng())
      }
      cp = this.adjustPostalCode(cp, codePays);

      if (this.departureMarker) {
        this.departureMarker.setMap(null);
      }

      this.departureMarker = new google.maps.Marker({
        position: place.geometry.location,
        map: this.map,
        title: 'Ville de départ',
        icon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
      });
      
      const cityString = city + ' ' + codePays + ' ' + cp;
      this.map.setCenter(place.geometry.location);
      this.addItinerary.get('departure').setValue(cityString.toUpperCase());
      this.addItinerary.get('departureRegion').setValue(region);
      this.addItinerary.get('departureCountry').setValue(country);
      this.updatePolyline();
    });

    this.arrivalAutocomplete.addListener('place_changed', async () => {
      const place = this.arrivalAutocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) {
        return;
      }
      const region = this.getRegionFromPlace(place);
      const codePays = this.getCountryCodeFromPlace(place);
      let cp = this.getPostalCodeFromPlace(place);
      const country = this.getCountryFromPlace(place);
      const city = place.name;

      if (!cp) {
        cp = await this.fetchPostalCode(place.geometry.location.lat(), place.geometry.location.lng())
      }
      cp = this.adjustPostalCode(cp, codePays);

      if (this.arrivalMarker) {
        this.arrivalMarker.setMap(null);
      }
      this.arrivalMarker = new google.maps.Marker({
        position: place.geometry.location,
        map: this.map,
        title: 'Ville d\'arrivée',
        icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
      });
      const cityString = city + ' ' + codePays + ' ' + cp;
      this.addItinerary.get('arrival').setValue(cityString.toUpperCase());
      this.addItinerary.get('arrivalRegion').setValue(region);
      this.addItinerary.get('arrivalCountry').setValue(country);
      this.updatePolyline();
    });
  }

  async fetchPostalCode(lat: number, lng: number): Promise <string> {
    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${this.googleMapsLoader.apiKey}`;

    try {
      const response: any = await this.http.get(geocodeUrl).toPromise();
      if (response.results && response.results.length > 0) {
        const postalCode = this.getPostalCodeFromGeocodeResult(response.results);
        return postalCode;
      } else {
        return '';
      }
    } catch (error) {
      console.error('Erreur lors de la récupération du code postal', error);
      return ''
    }
  }

  getPostalCodeFromGeocodeResult(results: any[]): string {
    for (const result of results) {
      for (const component of result.address_components) {
        if (component.types.includes("postal_code")) {
          return component.long_name;
        }
      }
    }
    return "";
  }

  adjustPostalCode(postalCode: string, countryCode: string): string {

    if (countryCode === 'FR' && postalCode.length >= 2) {
      return postalCode.substring(0, 2);
    }
    return postalCode;
  }

  getCountryFromPlace(place: any): string {
    for (const component of place.address_components) {
      if (component.types.includes("country")) {
        return component.long_name;
      }
    }
    return "";
  }

  getRegionFromPlace(place: any): string {
    for (const component of place.address_components) {
      if (component.types.includes("administrative_area_level_1")) {
        return component.long_name;
      }
    }
    return "";
  }

  getCountryCodeFromPlace(place: any): string {
    for (const component of place.address_components) {
      if (component.types.includes("country")) {
        return component.short_name; 
      }
    }
    return "";
  }

  getPostalCodeFromPlace(place: any): string {
    for (const component of place.address_components) {
      if (component.types.includes("postal_code")) {
        return component.long_name;
      }
    }
    return "";
  }

  updatePolyline(): void {
    
    if(this.departureMarker && this.arrivalMarker) {
      const request = {
        origin: this.departureMarker.getPosition(),
        destination: this.arrivalMarker.getPosition(),
        travelMode: google.maps.TravelMode.DRIVING
      };
      this.directionsService.route(request, (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          const directionsRenderer = new google.maps.DirectionsRenderer();
          directionsRenderer.setMap(this.map);
          directionsRenderer.setDirections(result);
          this.directionsRenderers.push(directionsRenderer);

          const leg = result.routes[0].legs[0];
          new google.maps.Marker({
            position: leg.start_location,
            map: this.map,
            title: 'Départ',
            icon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
          });
          new google.maps.Marker({
            position: leg.end_location,
            map: this.map,
            title: 'Arrivée',
            icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
          });
          
        } else {
          console.error('Erreur lors de la récupération des directions', status);
        }
      });
    }
  }
  
  onSubmit() {
    
    const departureLocation = this.departureMarker ? this.departureMarker.getPosition() : null;
    const arrivalLocation = this.arrivalMarker ? this.arrivalMarker.getPosition() : null;
    
    const transporteurData = this.prepareTransportData(departureLocation, arrivalLocation);

    this.directionsService.route({
      origin: departureLocation,
      destination: arrivalLocation,
      travelMode: google.maps.TravelMode.DRIVING
    }, (result, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        let distance = result.routes[0].legs[0].distance.text;
        distance = distance.replace(/[^\d,.]/g, ''); 
        distance = distance.replace(',', '.');
        transporteurData.distance = `${distance} km`;
        
        if (this.selectedTransport) {
          this.transporteurService.updateTransport(this.selectedTransport.id, transporteurData).subscribe((response) => {
            this.resetForm();
            this.getTransportsList();
            this.toastService.success('Itinéraire mis à jour avec succès');
          }, (error) => {
            this.toastService.error('Erreur lors de la mise à jour de l\'itinéraire');
          });
        } else {
          this.saveTransporteurData(transporteurData);
        } 
      } else {
        console.error('Erreur lors de la récupération des directions', status);
      }
    });
  }

  saveTransporteurData(data: TransportType) {
    if (!this.selectedCompany) {
      this.toastService.error('Veuillez sélectionner une société.');
    return;
    
    }
    const saveData = { ...data, company_id: this.selectedCompany }

    this.transporteurService.saveTransporteurData(saveData).subscribe((response) => {

      this.resetForm();
      this.getTransportsList();
      this.toastService.success('Itinéraire ajouté avec succès');
    }, (error) => { 
      this.toastService.error('Erreur lors de l\'ajout de l\'itinéraire');
    })
  }

  //reset form
  resetForm() {
    this.addItinerary.reset();
    if(this.departureMarker) {
      this.departureMarker = null;
    }
    if(this.arrivalMarker) {
      this.arrivalMarker = null;
    }
    this.clearDirections();
  }


  displayOnMap(): void {
    this.clearMap();
    this.transporteurs.forEach(trajet => {
      
      if (!trajet.departure || !trajet.arrival) {
        console.warn('Coordonnées manquantes ou invalides pour un trajet');
        return;
      }

      const departureLatLng = new google.maps.LatLng(trajet.departure.lat, trajet.departure.lng);
      const arrivalLatLng = new google.maps.LatLng(trajet.arrival.lat, trajet.arrival.lng);

      // Marqueur pour la ville de départ
      const departureMarker = new google.maps.Marker({
        position: departureLatLng,
        map: this.map,
        title: trajet.departure.city,
        icon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
      });
      this.markers.push(departureMarker);

      // Marqueur pour la ville d'arrivée
      const arrivalMarker = new google.maps.Marker({
        position: arrivalLatLng,
        map: this.map,
        title: trajet.arrival.city,
        icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
      });
      this.markers.push(arrivalMarker);

      const request = {
        origin: departureLatLng,
        destination: arrivalLatLng,
        travelMode: google.maps.TravelMode.DRIVING
      };

      this.directionsService.route(request, (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          const directionsRenderer = new google.maps.DirectionsRenderer({
            suppressMarkers: true
          });
          directionsRenderer.setMap(this.map);
          directionsRenderer.setDirections(result);
          this.directionsRenderers.push(directionsRenderer);

          //custom markers
          const leg = result.routes[0].legs[0];
          new google.maps.Marker({
            position: leg.start_location,
            map: this.map,
            title: 'Ville de départ',
            icon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
          });
          new google.maps.Marker({
            position: leg.end_location,
            map: this.map,
            title: 'Ville d\'arrivée',
            icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
          });

          //trajet.distance = result.routes[0].legs[0].distance.text;
        } else {
          console.error('Erreur lors de la génération du tracé routier', status);
        }
      });
    });
  }

  clearMap(): void {
    this.markers.forEach(marker => marker.setMap(null));
    this.markers = [];

    this.clearDirections()
  }
  
  clearDirections(): void {
    this.directionsRenderers.forEach(directionsRenderer => directionsRenderer.setMap(null));
    this.directionsRenderers = [];
  }

  getTransportsList() {
    let params = {}
    if (this.selectedCompany) {
      Object.assign(params, { company_id: this.selectedCompany });
    }
    if (this.filters.get('country').value) {
      Object.assign(params, { country: this.filters.get('country').value });
    }

    this.transporteurService.getTransportsList(params).subscribe((response) => {
      
      this.transporteurs = response.transporteurs;
      //console.log(this.transporteurs);
      this.displayOnMap();
      this.loadCountries();
    });
  }

  deleteTransport(id: number) {
    this.transporteurService.deleteTransport(id).subscribe((response) => {
      this.getTransportsList();
      this.clearMap();
      this.toastService.success('Itinéraire supprimé avec succès');
    }, (error) => {
      this.toastService.error('Erreur lors de la suppression de l\'itinéraire');
    })
  }

  editTransport(transport: TransportType) {
    //console.log(transport)
    this.filters.get('transporter_id').setValue(transport.company_id);
    this.selectedCompany = transport.company_id;
    this.addItinerary.get('departure').setValue(transport.departure.city);
    this.addItinerary.get('arrival').setValue(transport.arrival.city);

    this.addItinerary.get('infos').setValue(transport.infos);

    this.addItinerary.get('departureRegion').setValue(transport.departure.region);
    this.addItinerary.get('departureCountry').setValue(transport.departure.country);

    this.addItinerary.get('arrivalRegion').setValue(transport.arrival.region);
    this.addItinerary.get('arrivalCountry').setValue(transport.arrival.country);
    
    this.simulatePlaceSelection(transport.departure, 'departure');
    this.simulatePlaceSelection(transport.arrival, 'arrival');

    this.selectedTransport = transport;
    
    // Remplir les quantités
    if (transport.quantity && Array.isArray(transport.quantity)) {
      this.quantityFormArray.controls.forEach((control, i) => {
        control.setValue(transport.quantity.includes(this.quantityOptions[i]));
      });
    } else {
      this.quantityFormArray.controls.forEach(control => control.setValue(false));
    }

    // Remplir les types de véhicule
    if (transport.vehicleType && Array.isArray(transport.vehicleType)) {
      this.vehicleTypeFormArray.controls.forEach((control, i) => {
        control.setValue(transport.vehicleType.includes(this.vehicleTypeOptions[i]));
      });
    } else {
      this.vehicleTypeFormArray.controls.forEach(control => control.setValue(false));
    }

    // Remplir les jours
    if (transport.days && Array.isArray(transport.days)) {
      this.daysFormArray.controls.forEach((control, i) => {
        control.setValue(transport.days.includes(this.daysOptions[i]));
      });
    } else {
      this.daysFormArray.controls.forEach(control => control.setValue(false));
    }

  }

  simulatePlaceSelection(cityData: CityType, type: 'departure' | 'arrival') {
    const place = {
      name: cityData.city,
      address_components: [
        { long_name: cityData.region, short_name: cityData.region, types: ['administrative_area_level_1'] },
        { long_name: cityData.country, short_name: cityData.country, types: ['country'] },
      ],
      geometry: {
        location: new google.maps.LatLng(cityData.lat, cityData.lng)
      }
    };

    if (type === 'departure') {
      this.departureMarker = new google.maps.Marker({
        position: place.geometry.location,
        map: this.map,
        title: 'Ville de départ',
        icon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
      });
      this.map.setCenter(place.geometry.location);
    } else {
      this.arrivalMarker = new google.maps.Marker({
        position: place.geometry.location,
        map: this.map,
        title: 'Ville d\'arrivée',
        icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
      });
      this.map.setCenter(place.geometry.location);
    }

    // Mettre à jour la carte et l'itinéraire
    this.updatePolyline();
  }

  loadCountries(): void {
    this.transporteurService.getCountries().subscribe((countries: string[]) => {
      this.countries = countries;
    }, (error) => {
      console.error('Erreur lors de la récupération des pays', error);
    });
  }

  prepareTransportData(departureLocation = null,arrivalLocation = null): TransportType {
    const departure = this.addItinerary.get('departure').value;
    const departureRegion = this.addItinerary.get('departureRegion').value;
    const departureCountry = this.addItinerary.get('departureCountry').value;
    const arrival = this.addItinerary.get('arrival').value;
    const arrivalRegion = this.addItinerary.get('arrivalRegion').value;
    const arrivalCountry = this.addItinerary.get('arrivalCountry').value;
    const informations = this.addItinerary.get('infos').value;
    const selectedQuantities = this.addItinerary.value.quantity
      .map((v, i) => (v ? this.quantityOptions[i] : null))
      .filter(v => v !== null);

    const selectedVehicleTypes = this.addItinerary.value.vehicleType
      .map((v, i) => (v ? this.vehicleTypeOptions[i] : null))
      .filter(v => v !== null);

    const selectedDays = this.addItinerary.value.days
      .map((v, i) => (v ? this.daysOptions[i] : null))
      .filter(v => v !== null);

  
    let transporteurData: TransportType = {
      departure: { city: departure, region: departureRegion, country: departureCountry, lat: 0, lng: 0 }, // Vous pouvez ajouter lat/lng si besoin
      arrival: { city: arrival, region: arrivalRegion, country: arrivalCountry, lat: 0, lng: 0 }, // Vous pouvez ajouter lat/lng si besoin
      quantity: selectedQuantities,
      vehicleType: selectedVehicleTypes,
      days: selectedDays,
      infos: informations,
      distance: ''
    };

    if (departure && departureLocation) {
      transporteurData.departure = {
        city: departure,
        region: departureRegion,
        country: departureCountry,
        lat: departureLocation.lat(),
        lng: departureLocation.lng()
      };
    }

    if (arrival && arrivalLocation) {

      transporteurData.arrival = {
        city: arrival,
        region: arrivalRegion,
        country: arrivalCountry,
        lat: arrivalLocation.lat(),
        lng: arrivalLocation.lng()
      };
    } 

    return transporteurData;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/transporteur/transporteur.component.ts